(function () {
  // <-- Agrega aquí el variant ID de cada producto especial.
  // Ejemplo con el original + 4 nuevos (reemplaza estos números por los reales):
  const WRAP_VARIANT_IDS = [
    52776074281272, // Producto Especial (original)
    52776906490168, // Agarre a Presión
    52776906555704, // Agarre Bolita de Acero
    // 33333333333333, // Producto especial nuevo 3 (pendiente)
    // 44444444444444, // Producto especial nuevo 4 (pendiente)
  ];

  function storageKey(variantId) {
    return `wrapSync_wasPresent_${variantId}`;
  }

  async function getCartState() {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    let otherItemsQty = 0;
    const wrapLines = {}; // variantId -> item del carrito

    cart.items.forEach((item) => {
      if (WRAP_VARIANT_IDS.includes(item.variant_id)) {
        wrapLines[item.variant_id] = item;
      } else {
        otherItemsQty += item.quantity;
      }
    });

    return { cart, otherItemsQty, wrapLines };
  }

  async function syncOneWrap(variantId, otherItemsQty, wrapLine) {
    const key = storageKey(variantId);
    const wasPresent = localStorage.getItem(key) === 'true';
    const isPresentNow = !!wrapLine;

    const justAdded = isPresentNow && !wasPresent && otherItemsQty > 0;

    if (justAdded) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: wrapLine.key, quantity: otherItemsQty }),
        });

        const data = await res.json();

        if (!res.ok) {
          console.error('[wrap-sync] Error al sincronizar variante', variantId, ':', res.status, data);
          return false;
        }

        localStorage.setItem(key, 'true');
        return true; // se sincronizó con éxito
      } catch (err) {
        console.error('[wrap-sync] Excepción al sincronizar variante', variantId, ':', err);
        return false;
      }
    }

    localStorage.setItem(key, isPresentNow ? 'true' : 'false');
    return false; // no hubo cambio real esta vez
  }

  async function syncAllWraps() {
    const { otherItemsQty, wrapLines } = await getCartState();

    let anySynced = false;
    for (const variantId of WRAP_VARIANT_IDS) {
      const wrapLine = wrapLines[variantId];
      const synced = await syncOneWrap(variantId, otherItemsQty, wrapLine);
      if (synced) anySynced = true;
    }

    if (anySynced) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      // Carrito de página completa: recargamos para reflejar el cambio,
      // solo si estamos parados en la página del carrito.
      if (window.location.pathname === '/cart') {
        window.location.reload();
        return;
      }
    }

    showAllSuggestions();
  }

  async function showAllSuggestions() {
    const { otherItemsQty, wrapLines } = await getCartState();

    WRAP_VARIANT_IDS.forEach((variantId) => {
      const wrapLine = wrapLines[variantId];
      if (!wrapLine) return;

      const titleLink = document.querySelector(
        `a.cart-items__title[href*="variant=${variantId}"]`
      );
      if (!titleLink) return;

      const row = titleLink.closest('tr.cart-items_table-row') || titleLink.closest('tr');
      if (!row) return;

      const detailsCell = row.querySelector('td.cart-items_details') || row;

      let note = detailsCell.querySelector('.wrap-suggestion-note');
      if (!note) {
        note = document.createElement('p');
        note.className = 'wrap-suggestion-note';
        note.style.cssText = 'font-size: 0.85em; opacity: 0.75; margin-top: 4px;';
        detailsCell.appendChild(note);
      }

      if (wrapLine.quantity !== otherItemsQty) {
        note.textContent = `Te sugerimos: ${otherItemsQty} para tus accesorios en tu carrito`;
      } else {
        note.textContent = '';
      }
    });
  }

  // --- Interceptar fetch() para detectar CUALQUIER llamada a /cart/add ---
  // IMPORTANTE: bindeamos fetch a window UNA sola vez. Esto evita el error
  // "Illegal invocation" que ocurre cuando fetch se invoca con un `this`
  // distinto de window (como hace el motor de navegación por View Transitions
  // del tema Ritual), y que en el WebView de Instagram detenía la navegación
  // en todo el sitio.
  const originalFetch = window.fetch.bind(window);
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const result = originalFetch(...args);

    if (url.includes('/cart/add')) {
      result.then(() => {
        setTimeout(syncAllWraps, 600);
      });
    } else if (url.includes('/cart/change') || url.includes('/cart/update')) {
      result.then(() => {
        setTimeout(showAllSuggestions, 300);
      });
    }

    return result;
  };

  // Respaldo por si el tema sí dispara 'submit' de formulario tradicional
  document.addEventListener('submit', (e) => {
    if (e.target.matches && e.target.matches('form[action^="/cart/add"]')) {
      setTimeout(syncAllWraps, 600);
    }
  });

  // Cuando el cliente cambia manualmente alguna cantidad en el carrito
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name="quantity"], input[name="updates[]"]')) {
      setTimeout(showAllSuggestions, 600);
    }
  });

  document.addEventListener('cart:build', () => {
    setTimeout(showAllSuggestions, 200);
  });

  // Carrito de página completa: revisamos en cada carga de página.
  function init() {
    setTimeout(syncAllWraps, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();